import type { CfbSchoolCatalogEntry } from '../cfbSchoolCatalogTypes';
import {
  resolveTeamAccentColor,
  TEAM_CHIP_FALLBACK_ACCENT,
  type AccentColorResolution,
} from './accentColorResolver';

export type SchoolAccentInput = Pick<
  CfbSchoolCatalogEntry,
  'primary_color' | 'secondary_color' | 'tertiary_color' | 'quaternary_color' | 'colors_verified'
>;

export function resolveSchoolAccentColor(school: SchoolAccentInput): AccentColorResolution {
  if (!school.colors_verified) {
    return {
      accentColor: TEAM_CHIP_FALLBACK_ACCENT,
      source: 'fallback',
      contrastRatio: resolveTeamAccentColor({}).contrastRatio,
    };
  }

  return resolveTeamAccentColor({
    primaryColor: school.primary_color,
    secondaryColor: school.secondary_color,
    tertiaryColor: school.tertiary_color,
    quaternaryColor: school.quaternary_color,
  });
}
